import gql from 'graphql-tag'

export const CREATE_INSPECTION = gql`
  mutation createInspection($input: CreateInspectionInput!) {
    data: createInspection(input: $input) {
      id
    }
  }
`
